import { useAppSelector } from 'redux/hooks'
import { userRoleSelector } from 'redux/login/selectors'
import { PROFILE_DETAILS } from 'texts/profileDetails'
import { ContentWrapper } from 'ui/atoms/ContentWrapper'
import { ProfileDetailsFormProps } from './types'
import { ContactInformationForm } from './components/ContactInformationForm'
import { PaymentInformationForm } from './components/PaymentInformationForm'
import styles from './styles.module.scss'

export const ProfileDetailsForm = ({
  values,
  readOnly,
  countries,
  currencies,
}: ProfileDetailsFormProps) => {
  const role = useAppSelector(userRoleSelector)

  return (
    <>
      <ContentWrapper
        className={styles.form}
        title={PROFILE_DETAILS.FORM.CONTACT_FORM_TITLE}
        dataTestId="profile-details-form"
      >
        <ContactInformationForm
          countries={countries}
          role={role}
          stateId={values.companyStateID}
          readOnly={readOnly}
          selectedCountryId={Number(values?.companyCountryID)}
        />
      </ContentWrapper>
      <ContentWrapper
        className={styles.form}
        title={PROFILE_DETAILS.FORM.PAYMENT_FORM_TITLE}
      >
        <PaymentInformationForm
          currencies={currencies}
          role={role}
          readOnly={readOnly}
        />
      </ContentWrapper>
    </>
  )
}
